export default function Table({id, title, rows }) {
    return (
        <table className="w-full table-auto align-top divide-y-2 divide-white devide-4 text-left">
            <thead>
                <tr>
                    <th scope="col" 
                        colSpan={rows[0].columns.length} 
                        className="uppercase p-4 font-bold"
                        dangerouslySetInnerHTML={{__html:title}}
                        >
                    </th>
                </tr>
            </thead>
            <tbody className="divide-y divide-white divide-opacity-50">
                {rows.length > 0 && (
                    <>
                    {rows.map((d) => (
                        <tr key={`table-${id.toString()}-${d.id.toString()}`}>
                            {d.columns.map((c, index) => (
                                <td 
                                    key={`table-${id.toString()}-${d.id.toString()}-${c.id.toString()}`} 
                                    className={`py-2 px-4 align-top w-auto ${index == 0 ? 'font-semibold whitespace-nowrap': ''}`} 
                                    dangerouslySetInnerHTML={{__html:c.content}}></td>
                            ))}
                        </tr>
                    ))} 
                    </>
                )}
            </tbody>
        </table>
    );
}
